// replace the user pool region, id, and app client id details
const config = {
  REGION: "eu-west-1",
  USER_POOL_ID: "eu-west-1_h9W7bbLCd",
  USER_POOL_APP_CLIENT_ID: "19f43spp0gtngotoruukaejafl",
  IDENTITY_POOL_ID: "eu-west-1:5aec5c14-542c-476d-a7b2-e5eb74ffee0e",
};

export default config;
